import { useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';

export const GuideBreadcrumbs = ({
  currentTitle,
  currentPath,
  parentTitle = 'Gibraltar Weddings',
  parentPath = '/vendors',
  testIdPrefix = 'guide-breadcrumbs',
}) => {
  const items = useMemo(
    () => [
      { name: 'Home', path: '/' },
      { name: parentTitle, path: parentPath },
      { name: currentTitle, path: currentPath },
    ],
    [currentPath, currentTitle, parentPath, parentTitle],
  );

  useEffect(() => {
    if (typeof document === 'undefined' || typeof window === 'undefined') return;

    const origin = window.location.origin;
    const scriptId = `${testIdPrefix}-jsonld`;
    const payload = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: items.map((item, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        name: item.name,
        item: `${origin}${item.path}`,
      })),
    };

    let scriptTag = document.getElementById(scriptId);
    if (!scriptTag) {
      scriptTag = document.createElement('script');
      scriptTag.id = scriptId;
      scriptTag.type = 'application/ld+json';
      document.head.appendChild(scriptTag);
    }
    scriptTag.textContent = JSON.stringify(payload);

    return () => {
      const existing = document.getElementById(scriptId);
      if (existing) existing.remove();
    };
  }, [items, testIdPrefix]);

  return (
    <nav
      aria-label="Breadcrumb"
      className="flex flex-wrap items-center gap-2 text-sm text-stone-600"
      data-testid={`${testIdPrefix}-nav`}
    >
      <Link to="/" className="hover:text-[#5C0120] hover:underline" data-testid={`${testIdPrefix}-link-home`}>
        Home
      </Link>
      <span aria-hidden="true" className="text-stone-400">&gt;</span>
      <Link to={parentPath} className="hover:text-[#5C0120] hover:underline" data-testid={`${testIdPrefix}-link-parent`}>
        {parentTitle}
      </Link>
      <span aria-hidden="true" className="text-stone-400">&gt;</span>
      <span className="font-medium text-[#5C0120]" data-testid={`${testIdPrefix}-current`}>
        {currentTitle}
      </span>
    </nav>
  );
};
